<div class="tw-p-2 tw-pl-4 tw-pb-4 tw-grid tw-gap-4 lendio-density-2">
  <section class="tw-pb-2">
    <div class="column-grid tw-gap-4 tw-grid-cols-[1fr_auto_auto]">
      <h1>DSCR Results:</h1>
      <mat-spinner *ngIf="dscrStateLoading()" [diameter]="24"/>
      <button mat-stroked-button
              [color]="'primary'"
              [disabled]="dscrStateLoading()"
              (click)="reprocessDscr()">
        Rerun DSCR
      </button>

    </div>
    <ng-container *ngIf="showMaxNewLoanAmounts()">
      <div *ngFor="let lender of maxNewLoanAmountsByLender();" class="column-grid tw-gap-4 tw-justify-between tw-w-[300px]">
        <span>{{lender.lenderName}}:</span>
        <span>{{lender.maxNewLoanAmount | currency}}</span>
      </div>
      <div class="column-grid tw-gap-2 tw-justify-start tw-place-items-center tw-mt-2">
        <span class="tw-italic">Lender Name: Maximum new loan amount</span>
        <mat-icon class="tw-text-base !tw-h-min !tw-w-min" [matTooltip]="'The maximum new loan amount (per Lender) that will not cause the Borrower to have a DSCR lower than the Lender\'s defined minimum Global/Business DSCR'">info_outline</mat-icon>
      </div>
    </ng-container>
    <mat-divider/>
  </section>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <div class="column-grid tw-w-full tw-pr-4 tw-justify-between tw-place-items-center tw-gap-2">
        <h2 class="!tw-mb-0">Tax Documents & Information</h2>
      </div>
    </mat-expansion-panel-header>
    <div class="column-grid tw-gap-4 tw-mb-2 tw-justify-start tw-auto-cols-min tw-place-items-center">
      <mat-form-field class="no-subscript">
        <mat-label>Personal Debts Payment</mat-label>
        <span matTextPrefix>$</span>
        <input matInput type="number"
               [readonly]="borrowerValuesLoading()"
               [formControl]="personalDebtPaymentControl"
               (change)="handleManualInputChange($event, personalDebtPaymentAmountValue())"/>
      </mat-form-field>
      <mat-form-field class="no-subscript">
        <mat-label>Real Estate Payment</mat-label>
        <span matTextPrefix>$</span>
        <input matInput type="number"
               [readonly]="borrowerValuesLoading()"
               [formControl]="mortgagePaymentControl"
               (change)="handleManualInputChange($event, mortgagePaymentAmountValue())"/>
      </mat-form-field>
      <mat-form-field class="no-subscript">
        <mat-label>Number of Adults</mat-label>
        <input matInput type="number"
               [readonly]="borrowerValuesLoading()"
               [formControl]="numAdultsControl"
               (change)="handleManualInputChange($event, numAdultsValue())"/>
      </mat-form-field>
      <mat-form-field class="no-subscript">
        <mat-label>Number of Children</mat-label>
        <input matInput type="number"
               [readonly]="borrowerValuesLoading()"
               [formControl]="numChildrenControl"
               (change)="handleManualInputChange($event, numChildrenValue())"/>
      </mat-form-field>
      <div *ngIf="borrowerValuesLoading()">
        <mat-spinner [diameter]="24"/>
      </div>
    </div>
    <div class="tw-grid tw-gap-4 tw-pt-2 tw-grid-cols-[repeat(auto-fill,minmax(300px,1fr))] tw-auto-rows-[280px]">
      <mat-card class="!tw-bg-lendio-cool-gray-10">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>Business Tax Returns</mat-card-title>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content>
          <div class="tw-divide-y tw-max-w-full">
            <div class="tw-py-4" *ngFor="let requirement of businessRequirements()">
              <app-dscr-doc-requirement [requirement]="requirement"
                                        [borrowerDocuments]="borrowerDocuments()"
                                        [category]="'businessTaxReturns'"/>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngFor="let contact of ownerContacts()">
        <mat-card-header>
          <mat-card-title>
            <div class="tw-w-full tw-max-w-full tw-overflow-hidden tw-grid">
              <span [matTooltip]="contact.first + ' ' + contact.last" class="tw-block tw-overflow-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-w-full tw-max-w-full">
                {{ contact.first }} {{ contact.last }}
              </span>
            </div>
          </mat-card-title>
          <mat-card-subtitle class="!tw-grid tw-grid-flow-col tw-justify-start tw-gap-4 tw-place-items-center">
            <span>
              ({{ contact.percentOwnership }}% owner)
            </span>
            <mat-chip *ngIf="contact.isPrimary">Primary</mat-chip>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="tw-divide-y tw-max-w-full">
            <div class="tw-py-4" *ngFor="let requirement of contact.personalTaxDocReqs">
              <app-dscr-doc-requirement [requirement]="requirement"
                                        [borrowerDocuments]="unassignedBorrowerDocuments()"
                                        [category]="'personalTaxReturns'"
                                        [contact]="contact"
                                        [ownerDocumentsWithNoYear]="contact.ownerDocumentsWithNoYear"
              />
            </div>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <h2 class="!tw-mb-0">Profit & Loss Statements</h2>
    </mat-expansion-panel-header>
    <div class="tw-py-2 tw-mb-2 tw-w-[260px]">
      <div class="column-grid tw-gap-4 tw-place-items-center tw-justify-between">
        <h2 class="!tw-mb-2">Current Year:</h2>
        <button mat-flat-button (click)="editCurrentYearProfitLoss()">Edit</button>
      </div>

      <div *ngFor="let item of currentYearProfitLoss()" class="column-grid tw-gap-2 tw-justify-between">
        <span class="tw-font-bold">{{item.title}}</span>
        <span>{{item.value | currency}}</span>
      </div>
    </div>
    <mat-divider/>
    <app-profit-loss-items-table/>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <div class="column-grid tw-w-full tw-pr-4 tw-justify-between tw-place-items-center">
        <h2 class="!tw-mb-0">Debt Schedules</h2>
        <button mat-flat-button (click)="$event.stopPropagation(); newDebtScheduleItem();">
          New
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-expansion-panel-header>
    <app-debt-schedule-items-table/>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="canSearchTaxForms()">
    <mat-expansion-panel-header>
      <h2 class="!tw-mb-0">Tax Form Data</h2>
    </mat-expansion-panel-header>
    <div>
      <mat-form-field class="mt-4">
        <mat-label>Search Fields</mat-label>
        <input matInput [formControl]="taxDocSearchControl">
      </mat-form-field>

      <div class="column-grid tw-gap-6">
        <div>

          <h1>Personal Tax Form Fields</h1>
          <mat-divider/>
          <div *ngFor="let doc of personalDocumentsData()" class="tw-mb-1">
            <h2 class="mt-2 !tw-italic">{{ doc.title }}</h2>
            <div *ngFor="let form of doc.data">
              <h2>{{ form.title | titlecase }}</h2>
              <div *ngFor="let field of form.fields" class="tw-mb-1">
                <div class="column-grid tw-gap-4 tw-grid-cols-[400px_auto]">
                  <span>{{ field.key }}</span>
                  <span>{{ field.value | currency }}</span>
                </div>
                <mat-divider/>
              </div>
            </div>
          </div>

        </div>

        <div>

          <h1>Business Tax Form Fields</h1>
          <mat-divider/>
          <div *ngFor="let doc of businessDocumentsData()" class="tw-mb-1">
            <h2 class="mt-2 !tw-italic">{{ doc.title }}</h2>
            <div *ngFor="let form of doc.data">
              <h2>{{ form.title | titlecase }}</h2>
              <div *ngFor="let field of form.fields" class="tw-mb-1">
                <div class="column-grid tw-gap-4 tw-grid-cols-[400px_auto]">
                  <span>{{ field.key }}</span>
                  <span>{{ field.value }}</span>
                </div>
                <mat-divider/>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </mat-expansion-panel>
</div>
